module.exports = __webpack_public_path__ + "static/hawaii-2-2f324b0c765b0fee7d2909336e635f39.png";